import { render, staticRenderFns } from "./BaseIconButton.vue?vue&type=template&id=6396e0da&scoped=true"
import script from "./BaseIconButton.vue?vue&type=script&lang=js"
export * from "./BaseIconButton.vue?vue&type=script&lang=js"
import style0 from "./BaseIconButton.vue?vue&type=style&index=0&id=6396e0da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6396e0da",
  null
  
)

export default component.exports